<template>
  <b-container>
    <b-card>
      <b-breadcrumb>
          <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
          <b-breadcrumb-item active>Appointments</b-breadcrumb-item>
      </b-breadcrumb>
      <h3>{{ward.ward_name}}  Appointments</h3>
      <b-row>
        <b-col>
          <b-button class="mb-2" variant="primary" :to="{name: 'appointment-detail', params: { 'wardId': wardId}}" >Schedule <font-awesome-icon icon="plus" /></b-button>
        </b-col>
      </b-row>
        <b-row class="mb-3 mt-3">
            <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'search']"/>
      </b-input-group-prepend>
                <b-form-input v-model="searchTerm" placeholder="Search for Appointments" @input="delaySearchAppointments"></b-form-input>
                  </b-input-group>
                <b-form-checkbox class="mt-2" v-model="filterByDate" name="check-button" variant="primary" switch>
                  {{(filterByDate)? "Hide appointments date filter": "Filter by appointment date"}}
                </b-form-checkbox>
            </b-col>
          <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'filter']"/>
      </b-input-group-prepend>
            <b-form-select
                id="input-3"
                v-model="filterStatus"
                :options="filterStatusOptions"
                @change="searchAppointments(0)"
            ></b-form-select>
                  </b-input-group>
            </b-col>
        </b-row>
      <b-row>
          <b-col>
          <b-calendar
            v-if="filterByDate"
            variant="primary"
            v-model="dateFilterSearch"
            @context="onContext"
            locale="en-US"
            :hide-header="true"
            label-help="Use cursor keys to navigate appointment dates"
            @input="searchByDate"
            :value-as-date="true"
            :min="minDate"
          >
            <div class="d-flex" dir="ltr">
              <b-button
                size="sm"
                variant="outline-danger"
                v-if="dateFilterSearch"
                @click="clearTodayDate"
              >
                Clear date
              </b-button>
              <b-button
                size="sm"
                variant="outline-primary"
                class="ml-auto"
                @click="setTodayDate"
              >
                Set Today
              </b-button>
            </div>
          </b-calendar>
          </b-col>
      </b-row>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    class="mb-3 mt-3"
                    stacked
                    striped
                    show-empty
                    responsive
                    empty-text="No Appointments to show"
                    outlined>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                   <template #cell(appointment_date)="row">
                     {{$moment.utc(row.item.appointment_date).local().format('LLLL')}}
                   </template>
                  <template #cell(organizing_contact)="row">
                    <span v-if="row.item.organizing_contact">
                      {{(row.item.organizing_contact.title!==null)?row.item.organizing_contact.title + " ": ""}}{{row.item.organizing_contact.first_name}} {{row.item.organizing_contact.last_name}} ({{row.item.organizing_contact.phone_number}})
                    </span>
                    <span v-else class="text-muted">Public Appointment</span>
                  </template>
                  <template #cell(attendee_contacts)="row">
                    {{flattenOutAttendees(row.item.attendee_contacts)}}
                  </template>
                  <template #cell(appointment_type)="row">
                    {{row.item.appointment_type}} {{(row.item.appointment_type==='OTHER' && row.item.appointment_other_reason !==null)?`- [${row.item.appointment_other_reason}]`:''}}
                  </template>
                    <template v-slot:cell(action)="row">
                        <span :id="'tooltip-updated-' + row.index">
                            <b-button
                            :key="row.item.appointment_id"
                            :to="{name: 'appointment-detail', params: { 'wardId': wardId, 'appointmentId': row.item.appointment_id}}"
                            variant="outline-secondary">
                            <font-awesome-icon icon="edit" />
                        </b-button>
                            </span>

            </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
                <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchAppointments(currentPage-1)">Prev</b-button>
                    <b-button @click="searchAppointments(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>
<script>
import { AppointmentApi } from "@/app/appointments/appointmentApi";
import handleError from "@/errorHandler";
import _ from "lodash";

export default {
  name: "AppointmentList",
  props: {
    wardId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      ward: {
        ward_name: null
      },
      searchTerm: null,
      nextPage: {
        aux_id: null,
        pk_id: null,
        gsi_pk: null,
        gsi_sk: null,
        page_size: 10,
        search_term: null
      },
      prevPage: {
        aux_id: null,
        pk_id: null,
        gsi_pk: null,
        gsi_sk: null,
        page_size: 10,
        search_term: null
      },
      pages: [],
      currentPage: 0,
      lastPage: 0,
      dateFilterSearch: null,
      filterByDate: false,
      filterStatus: "SCHEDULED",
      filterStatusOptions: [],
      minDate: null,
      table: {
        id: "appointment-list",
        fields: [
          {
            key: "appointment_date",
            label: "Scheduled For"
          },
          {
            key: "appointment_type",
            label: "Reason",
          },
          {
            key: "organizing_contact",
            label: "With Who"
          },
          {
            key: "appointment_location",
            label: "Where"
          },
          {
            key: "attendee_contacts",
            label: "Attendee/s"
          },
          {
            key: "action",
            label: "Edit"
          }
        ],
        items: [],
        isBusy: false,
        totalRows: 0,
        page: {
          index: 0,
          size: 10
        },
      }
    }
  },
  async mounted () {
    this.pages.push(this.nextPage);
    this.minDate = new Date();
    this.filterStatusOptions.push({
      value: null,
      text: "Select a appointment filter"
    })
    this.filterStatusOptions = this.filterStatusOptions.concat(this.$store.state.frontEndSettings.appointment_states);
    await this.searchAppointments(0);
  },
  methods: {
    onContext(ctx) {
    },
    async searchByDate(val){
      await this.searchAppointments(0);
    },
    clearTodayDate() {
      this.dateFilterSearch = null;
    },
    setTodayDate(){
        const now = new Date()
        this.dateFilterSearch = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },
    async searchAppointments(page) {
      if (page < 0) {
        return;
      }
      if (page > this.pages.length - 1) {
        return;
      }
      let payload = this.pages[page]
      this.table.isBusy = true;
      payload.search_term = this.searchTerm;
      if (this.dateFilterSearch !== null && this.filterByDate) {
        let d = new Date();
        if (this.dateFilterSearch.getDate() === d.getDate()) {
          this.dateFilterSearch.setHours(d.getHours());
        }
        payload.date_filter_value = this.toIsoString(this.dateFilterSearch);
      } else {
        payload.date_filter_value = null;
        this.clearTodayDate();
      }
      if(this.filterStatus !== null && this.filterStatusOptions.length > 0){
        payload.appointment_state = this.filterStatus;
      }
      try {
        const { data } = await AppointmentApi.searchAppointments(this.wardId, payload);
        if (data.last_evaluated_key !== null) {
          if (!this.existInPageList(data.last_evaluated_key, this.pages))
            this.pages.push(data.last_evaluated_key);
        }
        this.table.items = data.result;
        this.table.isBusy = false;
        this.currentPage = page;
        this.ward = data.ward;
      } catch (e) {
        handleError(e, "Failed to fetch Appointments")
      }

    },
    existInPageList(obj, list) {
      if(list.length==0) return false;
      var i;
      for (i = 0; i < list.length; i++) {
        if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
          return true;
        }
      }
      return false;
    },
    async filterAppointments() {
      this.pages = [];
      this.currentPage = 0;
      this.lastPage = 0;
      this.pages.push(this.nextPage);
      await this.searchAppointments(0);
    },
    flattenOutAttendees(attendees) {
      let out_response = []
      attendees.forEach((attendee) => {
        out_response.push(`${attendee.first_name} ${attendee.last_name} (${attendee.phone_number})`);
      })
      return out_response.join(', ');
    },
    delaySearchAppointments: _.debounce(async function() {
      await this.searchAppointments(0);
    }, 500),
    toIsoString(date) {
        var tzo = -date.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                return (num < 10 ? '0' : '') + num;
            };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    }
  }
}
</script>
